// @ts-nocheck

export const isCypressRunning = Boolean(window.Cypress);
